import React, {Component} from 'react'
import PropTypes from 'prop-types';

export default class FilterButton extends Component
{
    static propTypes = {
        name: PropTypes.string,
        clickHandler: PropTypes.func
    };

    constructor(props) {
        super(props)

        this.state = {
            checked: true
        };
    }

    onChangeHandler() {
        this.props.clickHandler(!this.state.checked)
        this.setState({checked: !this.state.checked})
    }

    render() {
        return (
            <div className="form-check form-check-inline">
                <label className="form-check-label">
                    <input className="form-check-input" type="checkbox" checked={this.state.checked} onChange={() => this.onChangeHandler(this)}/>
                    <span className="form-check-sign"/>
                    {this.props.name}
                </label>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./React/src/components/LabelSearch/FilterButton.js